import { Component, inject, Input } from '@angular/core';
import { GtmService } from '@core/utils-v2/gtm/gtm.service';

declare let dataLayer: any;

@Component({
  selector: 'app-concepto-mobile',
  templateUrl: './concepto-mobile.component.html',
  styleUrls: ['./concepto-mobile.component.scss'],
})
export class ConceptoMobileComponent {
  @Input() set concepto(value: any) {
    this.caja = value;
  }
  private readonly gmtService: GtmService = inject(GtmService);

  caja: any;

  goToCategory(url: string) {
    this.gmtService.click({
      dataLayer,
      textId: this.caja?.data?.title,
      prefix: 'category-box',
    });
    window.location.href = url;
  }
}
